"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardContextProvider = exports.CardContext = exports.compactCardContext = exports.defaultCardContext = void 0;

var _react = require("react");

var defaultCardContext = {
  compact: false
};
exports.defaultCardContext = defaultCardContext;
var compactCardContext = {
  compact: true
};
exports.compactCardContext = compactCardContext;
var CardContext = (0, _react.createContext)(defaultCardContext);
exports.CardContext = CardContext;
var Provider = CardContext.Provider;
exports.CardContextProvider = Provider;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3729/js/context/CardContext.js
// module id = 409
// module chunks = 209 210 211 212